import React, { useEffect, useState } from 'react';
import { CardSection, CardSectionCover } from '../RelatedArticlesNew/styled';
import { ArticleHeading, ArticleList } from './styled';
// import AdsBanner from "../AdsBanner";

export default function InthisArticleSection(props) {
  const { data, video, showConsultStrip, articleData, formId } = props;

  const [extraxtedContent, setExtraxtedContent] = useState({});
  const [extractedHeadings, setExtractedHeadings] = useState([]);
  const [fullElement, setFullElement] = useState([]);
  const [activeindex, setActiveIndex] = useState(0);

  function getArticleHeadings() {
    if (typeof window != 'undefined') {
      var span = document.createElement('span');
      span.innerHTML = data?.body;

      // var arr = Array.from(span.getElementsByTagName("h2"));
      // var arr2 = Array.from(span.getElementsByTagName("strong"));
      // console.log('concat', arr1.concat(arr2));
      // let originalArray = arr1.concat(arr2);
      // return originalArray;
      // return arr;

      var arr = [];
      if (!document) return arr;
      var all_el = Array.from(span.getElementsByTagName('*'));
      for (var i = 0, n = all_el.length; i < n; i++) {
        if (/^h\d{1}$/gi.test(all_el[i].nodeName)) {
          arr.push(all_el[i]);
        }
      }
      return arr;
      // var arr = Array.from(span.getElementsByTagName("h2"));
      // var arr1 = Array.from(span.getElementsByTagName("h3"));
      // let originalArray = arr.concat(arr1);
      // return originalArray;
    }
  }

  useEffect(() => {
    if (extraxtedContent.length > 0) {
      let headings = [];
      extraxtedContent?.forEach((element) => {
        headings.push(element.innerHTML);
      });
      setExtractedHeadings(headings);
    }
  }, [extraxtedContent]);

  useEffect(() => {
    if (data?.body) {
      setExtractedHeadings([]);
      setExtraxtedContent(getArticleHeadings());
    }
  }, [data?.body]);

  useEffect(() => {
    if (extraxtedContent.length > 0) {
      let headings = [];
      let fullItem = [];
      extraxtedContent?.forEach((element) => {
        element['id'] = getPlainText(element?.innerHTML);
        headings.push(element.innerHTML);
        fullItem.push(element);
      });
      setFullElement(fullItem);
      setExtractedHeadings(headings);
    }
  }, [extraxtedContent]);

  // const activeArticleHandler = (index) => {
  //     document
  //         .getElementsByTagName("h2")
  //         [index].scrollIntoView({ behavior: "smooth", block: "center" });

  const activeArticleHandler = (index, element) => {
    const tagName = fullElement[index].tagName;
    const VariableDocument = document.getElementById('articleDetail');
    const tagsCollection = Array.from(
      VariableDocument?.getElementsByTagName(tagName),
    );
    const clickedIndex = getClickedElementIndex(tagsCollection, element);
    VariableDocument?.getElementsByTagName(tagName)[
      clickedIndex
    ]?.scrollIntoView({ behavior: 'smooth', block: 'center' });

    setActiveIndex(index);
  };
  const getPlainText = (string) => {
    let text = string.replace(/(<([^>]+)>)/gi, '');
    return text;
  };
  const getClickedElementIndex = (collection, elementToCheck) => {
    for (let index = 0; index < collection.length; index++) {
      if (getPlainText(collection[index].innerHTML) === elementToCheck) {
        return index;
      }
    }
    return 0;
  };

  return (
    <CardSectionCover>
      <CardSection
        inThisArticle
        className={extractedHeadings?.length > 0 ? 'visible' : 'notVisible'}
      >
        <ArticleHeading>In this {video ? 'Video' : 'Article'}</ArticleHeading>
        <ArticleList>
          {extractedHeadings?.map((element, index) => {
            return (
              <li
                key={`in_this_article${index}`}
                className={index == activeindex ? 'selected' : ''}
                onClick={() =>
                  activeArticleHandler(index, getPlainText(element))
                }
              >
                {getPlainText(element)}
              </li>
            );
          })}
        </ArticleList>
        {/* {isDesktopUser() && (
                    <AdsBanner
                        data-ad-slot="1751289035"
                        data-ad-format="auto"
                        data-full-width-responsive="true"
                    />
                )} */}
      </CardSection>
      {/* {showConsultStrip && (
                <ConsultationCategory
                    articleData={articleData}
                    data={consultationData}
                    formId={formId}
                />
            )} */}
    </CardSectionCover>
  );
}
